import { parseEntityIdFromGroupedLeafRowId } from '@aline/common';
import { getIsPlainRecord } from 'src/utils/get-is-plain-record';

import type { WorkflowListGroupRow, WorkflowListRow } from './WorkflowsList';

export function getIsWorkflowListWorkflowRow(row: unknown): row is WorkflowListRow {
  return getIsPlainRecord(row) && row.__typename === 'Workflow';
}

export function getIsWorkflowListGroupRow(row: unknown): row is WorkflowListGroupRow {
  return getIsPlainRecord(row) && row.isGroupRow === true;
}

export function getWorkflowIdFromListRow(row: Pick<WorkflowListRow, 'id' | 'workflowId'>): string {
  if (row.workflowId) return row.workflowId;
  return parseEntityIdFromGroupedLeafRowId(row.id);
}
